import { useCallback, useEffect, useRef } from 'react';
import { useIdleTimer } from 'react-idle-timer';
import googleAnalyticsService from '../../services/GoogleAnalyticsService';
import { getHeaderVersion } from '../../util/getHeaderVersion';

const IDLE_TIMEOUT = 60 * 1_000;

const useCategoryClick = () => {
    const startTimerRef = useRef<number | undefined>(undefined);
    const firstClickRef = useRef(false);

    useEffect(() => {
        startTimerRef.current = window.performance.now();
        return () => {
            startTimerRef.current = undefined;
        };
    }, []);

    const handleIdle = useCallback(() => {
        startTimerRef.current = undefined;
    }, []);

    const handleActive = useCallback(() => {
        if (!firstClickRef.current) {
            startTimerRef.current = window.performance.now();
        }
    }, []);

    useIdleTimer({
        timeout: IDLE_TIMEOUT,
        onIdle: handleIdle,
        onActive: handleActive,
    });

    return useCallback(
        ({
            categoryId,
            categoryName,
            categoryLevel,
            navLocation,
        }: {
            categoryId: string;
            categoryName: string;
            categoryLevel: number;
            navLocation?: string;
        }) => {
            if (!googleAnalyticsService.isInHeaderExperiment()) return;

            const ttf =
                startTimerRef.current !== undefined
                    ? window.performance.now() - startTimerRef.current
                    : undefined;

            googleAnalyticsService.trackEvent('header_category_click', {
                header_version: getHeaderVersion(),
                header_nav_location: navLocation,
                header_category_id: categoryId,
                header_category_name: categoryName,
                header_category_level: categoryLevel,
                header_ttf_category_ms: ttf,
            });

            firstClickRef.current = true;
            startTimerRef.current = undefined;
        },
        []
    );
};

export default useCategoryClick;
